import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { EventError } from 'shell/models/event-error';
import { HttpResponseList } from 'shell/models/http-response';
import { ErrorEventsClient } from '../list/types';

export interface EventsError {
  pageInfo:
    | {
        totalCount: number;
        page: number;
        pageSize: number;
      }
    | undefined;
  eventsError: Array<ErrorEventsClient>;
}

export const transformEventsError = (
  response: AxiosResponse<HttpResponseList<EventError>>
): EventsError => {
  const data = response.data.payload?.list || [];
  const pageInfo = response.data.payload?.pageInfo;

  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  return {
    pageInfo,
    eventsError: data.map((eventError: EventError) => ({
      id: eventError?.id,
      dataTime: eventError?.dataOraPubblicazione
        ? DateTime.fromISO(eventError?.dataOraPubblicazione).toFormat('dd/MM/yyyy HH:mm:ss')
        : '',
      typeEventCode: eventError?.codiceTipoEvento,
      eventDescription: eventError?.descrizioneTipoEvento,
      subscriber: eventError?.descrizioneSottoscrittore,
      state: eventError?.statoElaborazione,
      hidden: {
        delete: true,
        edit: true,
      },
    })),
  };
};
